import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OmniChannelManagerService } from '@os-components';
import { environment } from '../../../environments/environment';
import { CountriesEffects } from '../../stores/countries/countries.effects';
import * as fromCountries from '../../stores/countries/countries.reducer';
import { ComponentsEffects } from '../../stores/market-components/components.effects';
import * as fromComponents from '../../stores/market-components/components.reducer';
import { RegulationsEffects } from '../../stores/regulations/regulations.effects';
import * as fromRegulations from '../../stores/regulations/regulations.reducer';
import { ResultCountEffects } from '../../stores/result-count/result-count.effects';
import * as fromResultCount from '../../stores/result-count/result-count.reducer';

let onlyPreviewServices = [OmniChannelManagerService];

if (!environment.preview) {
    onlyPreviewServices = [];
}
@NgModule({
    imports: [
        StoreModule.forFeature(fromCountries.countriesFeatureKey, fromCountries.reducer),
        StoreModule.forFeature(fromRegulations.regulationsFeatureKey, fromRegulations.reducer),
        StoreModule.forFeature(fromComponents.componentsFeatureKey, fromComponents.reducer),
        StoreModule.forFeature(fromResultCount.resultCountFeatureKey, fromResultCount.reducer),
        EffectsModule.forFeature([
            CountriesEffects,
            RegulationsEffects,
            ComponentsEffects,
            ResultCountEffects,
        ]),
    ],
    providers: [...onlyPreviewServices],
})
export class LandingPageModule {}
